export default __webpack_public_path__ + "9e4ccae9c5a1b669d8fa2648db220c3f.svg";